import { EVM } from "../bullrun/evm.js";
import { Solana } from "../bullrun/solana.js";
/**
 * Default wallet configuration passed to Turnkey's `createSuborgParams`.
 *
 * When a new user signs up via OTP (email or SMS) or OAuth, Turnkey creates a
 * sub-organization for them. This config tells Turnkey to also create a
 * "Main Wallet" with both an EVM and a Solana account so the user is
 * immediately ready to transact on both chains.
 *
 * Centralised here so web and mobile stay in sync — a mismatch causes new
 * users on one platform to get a wallet with different accounts than the other.
 */
export const DEFAULT_WALLET_CONFIG = {
    customWallet: {
        walletName: "Main Wallet",
        walletAccounts: [EVM.getWalletAccountConfig(), Solana.getWalletAccountConfig()],
    },
};
/**
 * Pre-built `createSuborgParams` covering every auth method that can trigger
 * a new sub-org. Drop this into the Turnkey provider config's
 * `auth.createSuborgParams` field.
 */
export const DEFAULT_CREATE_SUBORG_PARAMS = {
    emailOtpAuth: DEFAULT_WALLET_CONFIG,
    smsOtpAuth: DEFAULT_WALLET_CONFIG,
    oauth: DEFAULT_WALLET_CONFIG,
};
